import React, {
  useContext,
  useState,
  useEffect,
  useRef,
  Fragment,
} from "react";
import { useLocation } from "react-router";

import Filtros from "./Filtros";
import ListadoContext from "../context/ListadoContext";
import Tabla from "./Tabla/Tabla";

import Mapa from "./Mapa";
import Botonera from "../Botonera";
import HeaderConf from "../../components/HeaderConf";

function ListadoV2() {
  const {
    opcionesListado,
    datos,
    handleCancelar,
    loading,
    listadoBotones,
    mapaCab,
    tieneMapaCab,
    firstRender,
    requestNro,
    setqsBody,
    listadoExtensiones,
    reclamarAutoActivacion,

    // 👇 Necesitamos estos del Provider
    actualizarListado, // dispara la consulta con los filtros activos
    filtroActivo, // opcional, por si quisieras forzar con setFilter
    setFilter, // opcional, alternativa a actualizarListado
  } = useContext(ListadoContext);

  const [mapa, setMapa] = useState(opcionesListado.mapa_fijo === "s");
  // console.log(listadoBotones)
  const ocultarToggleMapa =
    (opcionesListado.usar_mapa === "s" &&
      opcionesListado.listado_ocultar === "s") ||
    opcionesListado.mapa_fijo === "s";

  const listadoBotonesInferiores = listadoBotones.filter(
    (b) => b.listado_boton_inferior === "s",
  );
  const actuarOnChange = opcionesListado.filtro_on_change === "s";

  const tablaVisible =
    opcionesListado.consultaEjecutada === "s" &&
    opcionesListado.listado_ocultar !== "s" &&
    (opcionesListado.mapa_fijo !== "s" ? !mapa : true);

  const mostrarDespues = tieneMapaCab
    ? mapaCab.orden !== 1 && tablaVisible
    : false;
  const mostrarAntes = tieneMapaCab
    ? mapaCab.orden === 1 && tablaVisible
    : tablaVisible;

  // ===== Auto-activar desde la URL =====
  const location = useLocation();
  const yaAutoEjecute = useRef(false);

  useEffect(() => {
    if (yaAutoEjecute.current) return;
    const qp = new URLSearchParams(location.search);
    const activar = (qp.get("activarListado") || "").toLowerCase();

    if (
      activar === "s" &&
      opcionesListado?.consultaEjecutada !== "s" &&
      reclamarAutoActivacion()
    ) {
      yaAutoEjecute.current = true;
      actualizarListado();
    }
  }, [
    location.search,
    reclamarAutoActivacion,
    opcionesListado?.consultaEjecutada,
    actualizarListado,
    filtroActivo,
    setFilter,
  ]);
  // =====================================
  const datosBuenos = datos ? datos[0] : []
  return (
    <div
      className={`animated fadeIn novedades_lista ${opcionesListado.className}`}
      data-component="ListadoV2"
      style={{ gridColumn: opcionesListado.grid_span ?? "1/-1" }}
    >
      <HeaderConf
        opciones={opcionesListado}
        className={"configuracion_pantalla_titulo_secundario"}
      />
      <Filtros
        tieneMapaCab={tieneMapaCab}
        opciones={opcionesListado}
        setMapa={setMapa}
        data={datos}
        actuarOnChange={actuarOnChange}
        ocultarToggleMapa={ocultarToggleMapa}
        setqsBody={setqsBody}
      />
      {mostrarAntes && tablaVisible ? <Tabla /> : <></>}

      {listadoExtensiones.length > 0 ? (
        listadoExtensiones.map((lc) => {
          if (lc.componente === "mapa") {
            return opcionesListado.usar_mapa === "s" && mapaCab ? (
              <Fragment key={lc.id_a}>
                <Mapa
                  display={mapa ? "inherit" : "none"}
                  data={datos}
                  cab={mapaCab}
                  firstRender={firstRender}
                  opcionesListado={opcionesListado}
                  requestNro={requestNro}
                />
              </Fragment>
            ) : (
              <></>
            );
          }
          if (lc.tipo.id === 24) {
            return (
              <Fragment key={lc.id_a}>
                <div>Listado Multiple no implementado</div>
                <div>{lc.id_a}</div>
              </Fragment>
            );
          }
          return <></>;
        })
      ) : (
        <></>
      )}

      {mostrarDespues && tablaVisible ? (
        <>
          <br />
          <Tabla />
        </>
      ) : (
        <></>
      )}

      <Botonera
        handleSubmit={() => null}
        handleCancelar={handleCancelar}
        loading={loading || opcionesListado.consultaEjecutada !== "s"}
        buscar={0}
        cancelar={0}
        acciones={listadoBotonesInferiores}
        className={"container_buttons_inferiores"}
        context={ListadoContext}
        submit={opcionesListado.submit_button}
        submit_handleSubmit={opcionesListado.submit_button_handleSubmit}
        submit_texto={opcionesListado.submit_texto}
        data={datosBuenos}
        hayDatos={datos?.length > 0}
        actuarOnChange={actuarOnChange}
      />
    </div>
  );
}

export default ListadoV2;
